module.exports = __webpack_public_path__ + "img/ET.00f4fb24.jpg";